import Verification from "@/domainObjects/hold/Verification";

export default class HoldActionItems {
    holdActionItemId: number;
    holdTicketId: number;
    actionItemDate: string | Date | null;
    actionItemShift: string;
    personComplRework: string;
    locations: string;
    location: string;
    quantity: number;
    verifiedBy: string;
    verification: Verification;
    qiHold: number;
    reworkHours: number;
    newHoldTicketId: number | null;

    constructor(){
        this.holdActionItemId = 0;
        this.holdTicketId = 0;
        this.actionItemDate = "";
        this.actionItemShift = "";
        this.personComplRework = "";
        this.locations = "";
        this.location = "";
        this.quantity = 0;
        this.verifiedBy = "";
        this.verification = new Verification();
        this.qiHold = 0;
        this.reworkHours = 0;
        this.newHoldTicketId = null;
    }
}